'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.iterator.js
// module id = 269
// module chunks = 0